import React, { useEffect, useState } from 'react'
import { useHistory, withRouter, Redirect } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { articlesApi } from '../../../../api/articlesApi'
import { routes } from '../../../../constantes/routes'
import { swalAlertError, swalSuccessGeneral } from '../../../../utils/swalAlert'
import ProductsFormGeneral from '../productsAuxForm/ProductsFormGeneral'
import Select from '../productsAuxForm/Select'
import _ from 'lodash'
import { swalTitle } from '../../../../constantes/swalTitle'
import { onSubmitText } from '../../../../constantes/onSubmitText'
import Header from '../../../header/Header'
import {
  familiesActions,
  productsActions,
} from '../../../../actions/articlesActions'
import { swalMssgs } from '../../../../constantes/swalMssgs'
import {
  familiesTypes,
  productsTypes,
} from '../../../../constantes/actionTypes'
import validators from '../../../../utils/validationsRegEx'

const NewProductsContainer = () => {
  const history = useHistory()

  const userProfile = useSelector((state) => state.userProfile)
  const categories = useSelector((state) => state.categories)
  const allTypesOfDocuments = useSelector((state) => state.typesOfDocuments)

  const dispatch = useDispatch()

  const newProduct = (product) => dispatch(productsActions.newProduct(product))
  const newFamily = (family) => dispatch(familiesActions.newFamily(family))

  const [inputs, setinputs] = useState({
    referencia: '',
    nombre: '',
    descripcion: '',
    id_TipoCategoria: '',
    id_ArticuloPadre: '',
    link: '',
    isArticuloFinal: false,
    businessUnits: [],
  })
  const [isDisable, setIsDisable] = useState(false)
  const [select, setSelect] = useState([])
  const [coverImage, setCoverImage] = useState({})
  const [images, setImages] = useState([])
  const [docs, setDocs] = useState([])

  // Variables globales para los selectores
  let countSelect = 0 //ponemos el contador a 0, debido a que sera mas facil para identificar el index
  let arrSelect = []

  // useEffect(() => {
  // }, [select])

  //********************** Funciones auxiliares para SELECTORES
  const getArticlesByCategoryId = async (idCategory) => {
    const response = await articlesApi.getArticlesByCategoryId(idCategory)
    return response.data
  }

  const getArticlesOfAFatherId = async (idArticle) => {
    const response = await articlesApi.getArticlesOfAFatherId(idArticle)
    return response.data
  }

  const handleChangeSelectorProductFamily = async (event, indexSelect) => {
    const value = event.target.value

    let articleListOfParent = await getArticlesOfAFatherId(parseInt(value)) // Devuelve los articulos hijos de padre value(id_Articulo)
    const isArticleFinal = await articleListOfParent.filter(
      (elem) => elem.isArticuloFinal,
    ) // Comprobamos si los articulos anteriores se trata de articulos/productos finales

    let isSelectorExists = await arrSelect.filter(
      (elem) => elem?.key === indexSelect.toString(),
    )[0] //Comprobamos si hemos selecionado un valor de un selector que ya esta en la lista

      // setSelect(arrSelect) // Actualizamos el estado de selectores
      // articleListOfParent = await getArticlesOfAFatherId(parseInt(value))
      // updateListSelect()

    if (arrSelect.length > parseInt(indexSelect + 1)) {

      // Hay que eliminar todos aquellos que tienen el contador/index mayor que el selector actual
      let deleteSelects = _.remove(arrSelect, function (elem) {
        return elem?.key > isSelectorExists?.key
      })
      countSelect = parseInt(deleteSelects[0]?.key)
      setSelect(arrSelect) // Actualizamos el estado de selectores
      articleListOfParent = await getArticlesOfAFatherId(parseInt(value))
      articleListOfParent = _.orderBy(articleListOfParent, ['nombre'], ['asc'])
      await updateListSelect(articleListOfParent)
    } else {

      // Con esto no permito que se pueda añadir productos dentro de un producto final
      if (isArticleFinal.length === 0) {
        countSelect++
        updateListSelect(articleListOfParent)
      }
      
    }
    updateIdArticleFather(value)

  }

  const handleChange = async (event) => {
    let value
    const name = event.target.name
    if (name === 'isArticuloFinal') {
      value = event.target.checked // toma el valor del checkbox
      if (value === false) {
        inputs.descripcion = ''
      }
    } else {
      value = event.target.value
      if (name === 'id_TipoCategoria') {
        let articleListOfParent = await getArticlesByCategoryId(parseInt(value))
        articleListOfParent = _.orderBy(
          articleListOfParent,
          ['nombre'],
          ['asc'],
        )
        setSelect([])
        updateListSelect(articleListOfParent)
      }
    }
    setinputs((inputs) => ({ ...inputs, [name]: value }))
  }

  const updateListSelect = (articleListOfParent) => {
    // Lo añadimos al estado

    setSelect((select) => [
      ...select,
      <Select
        key={countSelect}
        index={countSelect}
        inputs={inputs}
        articleListOfParent={articleListOfParent}
        handleChangeSelectorProductFamily={handleChangeSelectorProductFamily}
      />,
    ])
    // tambien lo  añadimos a la variable global
    arrSelect.push(
      <Select
        key={countSelect}
        index={countSelect}
        inputs={inputs}
        articleListOfParent={articleListOfParent}
        handleChangeSelectorProductFamily={handleChangeSelectorProductFamily}
      />,
    )
  }

  const updateIdArticleFather = (value) => {
    setinputs((inputs) => ({ ...inputs, ['id_ArticuloPadre']: value }))
  }

  //********************** Controlar los estados de la subida de archivos
  const uploadCoverImage = (coverImage) => {
    setCoverImage(coverImage[0])
  }

  const uploadImages = (imgs) => {
    setImages(imgs)
  }

  const uploadDocs = (documents, typeDoc) => {
    let docsInfo = {
      id_TiposDocumentos: typeDoc,
      docs: documents,
    }
    docs.length > 1
      ? //Actualizar el estado de un objeto dentro de un array
        docs.map((elem) => {
          if (elem !== undefined) {
            if (elem.id_TiposDocumentos === typeDoc) {
              setDocs(
                docs.map((object) => {
                  if (object.id_TiposDocumentos === typeDoc) {
                    return {
                      ...object,
                      id_TiposDocumentos: typeDoc,
                      docs: documents,
                    }
                  }
                  return object
                }),
              )
            }
          }
        })
      : setDocs((docs) => [...docs, docsInfo])
  }

  //********************** funcciones para el boton guardar

  const handleSubmit = async (event) => {
    event.preventDefault()
    setIsDisable(true)

    try {
      // Transformar businessUnits a id_NegocioUnidades para el backend
      const { businessUnits, ...productData } = inputs
      const dataToSend = {
        ...productData,
        id_NegocioUnidades: businessUnits || [],
      }

      let response
      let idArticle
      if (dataToSend.isArticuloFinal) {
        response = await newProduct(dataToSend)
        idArticle = response.payload
        await saveCoverImagen(idArticle)
        await saveImages(idArticle)
      } else {
        response = await newFamily(dataToSend)
        idArticle = response.payload
      }

      await saveDocs(idArticle) //si lo pongo aqui, todos los articulos pueden tener documentos
      if (
        response.type === familiesTypes.NEW_FAMILY_SUCCESS ||
        response.type === productsTypes.NEW_PRODUCT_SUCCESS
      ) {
        swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
        history.push(routes.PRODUCTS) // tendria q ir a ver articulo
      }
    } catch (error) {
      swalAlertError(error.payload)
      setIsDisable(false)
    }
  }

  const saveCoverImagen = async (idArticle) => {
    try {
      if (!_.isEmpty(coverImage)) {
        const formData = new FormData()
        formData.append('files[]', coverImage)
        formData.append('IsImagenPortada', true)
        formData.append('id_Articulo', idArticle)
        const response = await articlesApi.uploadFiles(formData)
        return response
      }
    } catch (error) {
      swalAlertError(
        'Error con la imagen de portada' + error.response.data ||
          error.response.statusText,
      )
      setIsDisable(false)
    }
  }

  const saveImages = async (idArticle) => {
    try {
      if (!_.isEmpty(images)) {
        if (images.length > 0) {
          const formData = new FormData()
          images.map((img) => {
            formData.append('files[]', img)
          })
          formData.append('id_Articulo', idArticle)
          const response = await articlesApi.uploadFiles(formData)
          return response
        }
      }
    } catch (error) {
      swalAlertError(
        'Error con las imágenes del prodcuto' + error.response.data ||
          error.response.statusText,
      )
      setIsDisable(false)
    }
  }

  const saveDocs = async (idArticle) => {
    if (!_.isEmpty(docs)) {
      let thereAreDocs = docs.filter((doc) => {
        return doc.docs.length > 0
      })
      if (thereAreDocs.length > 0) {
        thereAreDocs.map(async (doc) => {
          try {
            const formData = new FormData()
            if (doc.docs.length > 0) {
              doc.docs.map((file) => formData.append('files[]', file))
            }
            formData.append('id_TiposDocumentos', doc.id_TiposDocumentos)
            formData.append('id_Articulo', idArticle)
            formData.append('isDocument', true)
            const response = await articlesApi.uploadFiles(formData)
            return response
          } catch (error) {
            swalAlertError(
              'Error con la subida del documento' + doc + error.response.data ||
                error.response.statusText,
            )
            setIsDisable(false)
          }
        })
      }
    }
  }

  const validateForm = () => {
    return (
      validators.hasValue(inputs.nombre) &&
      validators.hasValue(inputs.id_TipoCategoria) &&
      (!inputs.isArticuloFinal ||
        (inputs.isArticuloFinal &&
          validators.hasValue(inputs.descripcion) &&
          inputs.isArticuloFinal
        )
      ) &&
      inputs.businessUnits &&
      inputs.businessUnits.length > 0
    )
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          <Header
            text={'Nuevo producto'}
            route={() => history.goBack()}
            backBtn={false}
          />
          <ProductsFormGeneral
            inputs={inputs}
            handleSubmit={handleSubmit}
            handleChange={handleChange}
            isDisable={isDisable || !validateForm()}
            categories={categories}
            select={select}
            allTypesOfDocuments={allTypesOfDocuments}
            uploadCoverImage={uploadCoverImage}
            uploadImages={uploadImages}
            uploadDocs={uploadDocs}
            textBtn={onSubmitText.Crear}
          />
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}

export default withRouter(NewProductsContainer)
